<template lang="pug">
  .component-client-subscriptions
    .action-bar
      .title
        h2 Client Subscriptions
      .action
        i.fa.fa-plus-circle.fa-2x(data-toggle="create-subscription")
    .tabs-inner-content.client-subscriptions.no-space
      #create-subscription.is-hidden(data-toggler="is-hidden", v-f="")
        client-plan-subscriber(:client_id="$route.params.id", @subscriptionAdded="subscriptionAdded")
      base-list(:dataLoader="dataLoader", :component="component" ref="tabbedList")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import ClientPlanSubscriber from "../ClientPlanSubscriber";
  import BaseList from "../../../pages/backoffice/BaseList";

  export default {
    name: "ClientSubscriptions",
    components: {
      BaseList,
      ClientPlanSubscriber,
    },
    data() {
      return {
        component: require('components/backoffice/Subscription')
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, {id: this.$route.params.id}).subscriptions((data) => {
          callback(data)
        })
      },
      subscriptionAdded(op) {
        if(op === 'added') {
          this.$refs.tabbedList.loadData(1)
        }
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .title
    display: inline-block
    width: 50%
  .action
    display: inline-block
    text-align: right
    width: 50%
</style>



// WEBPACK FOOTER //
// ClientSubscriptions.vue?0af91692